/* Marshall Scientific home sections — sliders + FAQ accordion.
   Runs globally so each split section initializes itself. Safe to load once. */
(function () {
  function initFaq(scope) {
    scope.querySelectorAll('.ms-faq-item').forEach(function (item) {
      var q = item.querySelector('.ms-faq-q');
      var a = item.querySelector('.ms-faq-a');
      if (!q || !a || q.dataset.msBound) return;
      q.dataset.msBound = '1';
      q.addEventListener('click', function () {
        var open = item.classList.toggle('open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        a.style.maxHeight = open ? (a.scrollHeight + 'px') : '0px';
      });
    });
  }

  /* Continuous "perpetual" marquee: clones the logos once and scrolls the
     track at a steady speed, looping seamlessly. No arrows, no stepping. */
  function initSliders(scope) {
    scope.querySelectorAll('[data-ms-slider]').forEach(function (slider) {
      if (slider.dataset.msBound) return;
      slider.dataset.msBound = '1';
      var track = slider.querySelector('.ms-slider-track');
      var vp = slider.querySelector('.ms-slider-vp');
      if (!track || !vp) return;
      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) return;

      // No manual controls in marquee mode.
      slider.querySelectorAll('.ms-sarrow').forEach(function (b) { b.style.display = 'none'; });

      // Duplicate the set once so translateX(-50%) lands on an identical frame.
      originals.forEach(function (s) {
        var c = s.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.dataset.msClone = '1';
        track.appendChild(c);
      });

      track.classList.add('ms-marquee');

      function per() {
        return window.innerWidth <= 900
          ? parseInt(slider.dataset.perSm || '2', 10)
          : parseInt(slider.dataset.per || '5', 10);
      }
      function layout() {
        var p = per();
        var all = Array.prototype.slice.call(track.children);
        var w = vp.clientWidth || slider.clientWidth;
        var sw = w / p;                       // one logo occupies 1/p of the viewport
        all.forEach(function (s) {
          s.style.flex = '0 0 ' + sw + 'px';
          s.style.width = sw + 'px';
          s.style.maxWidth = sw + 'px';
        });
        track.style.width = (sw * all.length) + 'px';
        // Speed: reuse the old autoplay value as seconds-per-logo, so the
        // marquee's pace still respects the section's "Autoplay" setting.
        var secPer = (parseInt(slider.dataset.autoplay || '0', 10) || 4000) / 1000;
        track.style.animationDuration = (originals.length * secPer) + 's';
      }
      layout();
      window.addEventListener('resize', layout);
    });
  }

  function initAll(scope) { initFaq(scope); initSliders(scope); }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  // Re-init when a section is edited/added in the theme editor
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }
})();
